export default {
  issues: {
    subtasks: {
      hint: 'Nhiệm vụ con: {done}/{total} đã xong',
    },
    types: {
      ISSUE_TYPE_EPIC: 'Epic',
      ISSUE_TYPE_STORY: 'Câu chuyện',
      ISSUE_TYPE_TASK: 'Nhiệm vụ',
      ISSUE_TYPE_BUG: 'Lỗi',
      ISSUE_TYPE_SUBTASK: 'Nhiệm vụ con',
    },
    priorities: {
      PRIORITY_HIGHEST: 'Cao nhất',
      PRIORITY_HIGH: 'Cao',
      PRIORITY_MEDIUM: 'Trung bình',
      PRIORITY_LOW: 'Thấp',
      PRIORITY_LOWEST: 'Thấp nhất',
    },
    create: {
      action: 'Tạo nhiệm vụ',
      inColumn: 'Nhiệm vụ',
      title: 'Nhiệm vụ mới',
      type: 'Loại',
      name: 'Tiêu đề',
      namePlaceholder: 'Cần làm gì',
      description: 'Mô tả',
      descriptionPlaceholder: 'Chi tiết, liên kết, tiêu chí hoàn thành',
      priority: 'Độ ưu tiên',
      assignee: 'Người thực hiện',
      assigneePlaceholder: 'Chưa giao',
      noMembers: 'Dự án chưa có thành viên',
      parent: 'Nhiệm vụ cha',
      parentPlaceholder: 'Không có nhiệm vụ cha',
      noParents: 'Không có nhiệm vụ phù hợp',
      dueDate: 'Hạn',
      submit: 'Tạo',
      created: 'Đã tạo nhiệm vụ {key}',
      errors: {
        title: 'Tiêu đề tối đa {limit} ký tự',
        failed: 'Không tạo được nhiệm vụ',
      },
    },
    list: {
      columns: {
        type: 'Loại',
        key: 'Mã',
        title: 'Tiêu đề',
        status: 'Trạng thái',
        priority: 'Ưu tiên',
        assignee: 'Người làm',
        due: 'Hạn',
      },
      groupBy: {
        label: 'Nhóm theo',
        status: 'trạng thái',
        assignee: 'người làm',
        priority: 'ưu tiên',
        type: 'loại',
        none: 'không nhóm',
      },
      select: 'Chọn {key}',
      selectAll: 'Chọn tất cả trên trang',
      selected: 'Đã chọn {count} nhiệm vụ',
      clearSelection: 'Bỏ chọn',
      bulk: {
        label: 'Thao tác với mục đã chọn',
        status: 'Trạng thái',
        assignee: 'Người thực hiện',
      },
      shown: 'Hiển thị {shown} trong {total}',
      pages: 'Các trang danh sách',
      prev: 'Trang trước',
      next: 'Trang sau',
      openIssue: 'Mở nhiệm vụ {key}',
      changeStatus: 'Đổi trạng thái',
      changeAssignee: 'Đổi người làm',
      assignFailed: 'Không đổi được người làm',
      noAssignee: 'Chưa giao',
      noStatus: 'Chưa có trạng thái',
      noPriority: 'Chưa có ưu tiên',
      noType: 'Chưa có loại',
      empty: {
        title: 'Chưa có nhiệm vụ',
        description: 'Hãy tạo nhiệm vụ đầu tiên — nó sẽ xuất hiện ở đây và trên bảng.',
      },
      error: {
        title: 'Không tải được danh sách',
        description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
      },
    },
  },
  issue: {
    back: 'Quay lại',
    titleLabel: 'Tên nhiệm vụ',
    saveFailed: 'Không lưu được thay đổi',
    today: 'hôm nay',
    yesterday: 'hôm qua',
    watch: 'Theo dõi',
    unwatch: 'Bỏ theo dõi',
    description: {
      empty: 'Thêm mô tả: điều kiện, liên kết, tiêu chí hoàn thành',
      edit: 'Nhấn để sửa',
    },
    history: {
      none: 'Chưa có thay đổi',
      more: 'Xem thêm',
      system: 'Hệ thống',
      created: ' đã tạo nhiệm vụ',
      changed: ' đã đổi {field}:',
      empty: '—',
      fields: {
        title: 'tên',
        description: 'mô tả',
        type: 'loại',
        priority: 'độ ưu tiên',
        assignee: 'người thực hiện',
        parent: 'nhiệm vụ cha',
        due_date: 'hạn',
        column: 'trạng thái',
        labels: 'nhãn',
        attributes: 'thuộc tính',
        deleted: 'xoá',
      },
    },
    subtasks: {
      title: 'Nhiệm vụ con',
      add: 'Thêm nhiệm vụ con',
      placeholder: 'Cần làm gì',
      failed: 'Không thể tạo nhiệm vụ con',
    },
    links: {
      empty: 'Chưa có liên kết',
      search: 'Mã hoặc tên nhiệm vụ',
      remove: 'Bỏ liên kết với {key}',
      types: {
        LINK_TYPE_BLOCKS: 'Chặn',
        LINK_TYPE_RELATES: 'Liên quan',
        LINK_TYPE_DUPLICATES: 'Trùng lặp',
        LINK_TYPE_CAUSES: 'Dẫn đến',
      },
      outbound: {
        LINK_TYPE_BLOCKS: 'chặn',
        LINK_TYPE_RELATES: 'liên quan đến',
        LINK_TYPE_DUPLICATES: 'trùng với',
        LINK_TYPE_CAUSES: 'dẫn đến',
      },
      inbound: {
        LINK_TYPE_BLOCKS: 'bị chặn bởi',
        LINK_TYPE_RELATES: 'liên quan đến',
        LINK_TYPE_DUPLICATES: 'bị trùng bởi',
        LINK_TYPE_CAUSES: 'gây ra bởi',
      },
    },
    comments: {
      placeholder: "Bình luận… ({'@'} để nhắc, DEV-NNN là liên kết nhiệm vụ)",
      send: 'Gửi',
      empty: 'Chưa có bình luận',
      more: 'Xem bình luận cũ hơn',
      edit: 'Sửa',
      remove: 'Xoá',
    },
    peek: {
      open: 'Mở trang',
      activity: 'Hoạt động',
    },
    dev: {
      title: 'GitLab',
      mr: {
        opened: 'Đang review',
        merged: 'Đã merge',
        closed: 'Đã đóng',
        draft: 'Bản nháp',
      },
      stand: {
        live: 'Môi trường đang chạy',
        removed: 'Môi trường đã gỡ',
      },
      pipeline: {
        success: 'Pipeline thành công',
        failed: 'Pipeline thất bại',
        running: 'Pipeline đang chạy',
        pending: 'Pipeline trong hàng đợi',
        created: 'Pipeline đã tạo',
        canceled: 'Pipeline đã huỷ',
        skipped: 'Pipeline bị bỏ qua',
        manual: 'Pipeline chờ chạy',
      },
    },
    pages: {
      title: 'Cơ sở tri thức',
      add: 'Liên kết trang',
      search: 'Tiêu đề hoặc nội dung trang',
      nothing: 'Không tìm thấy gì',
      remove: 'Bỏ liên kết trang «{title}»',
    },
    attachments: {
      title: 'Tệp đính kèm',
      add: 'Đính kèm tệp',
      sending: 'Đang tải lên…',
      remove: 'Xoá tệp {name}',
      count: '{count} tệp',
      kb: 'KB',
      mb: 'MB',
    },
    labels: {
      add: 'Thêm nhãn',
      remove: 'Bỏ nhãn {name}',
      search: 'Nhãn hoặc tên mới',
      create: 'Tạo «{name}»',
      none: 'Dự án chưa có nhãn nào',
    },
    activity: {
      label: 'Hoạt động của nhiệm vụ',
      comments: 'Bình luận',
      history: 'Lịch sử',
      links: 'Liên kết',
    },
    meta: {
      fold: 'Chi tiết · người thực hiện, hạn, nhãn',
      status: 'Trạng thái',
      assignee: 'Người thực hiện',
      reporter: 'Người tạo',
      priority: 'Độ ưu tiên',
      due: 'Hạn',
      noDue: 'Không có hạn',
      labels: 'Nhãn',
      services: 'Dịch vụ',
      watchers: 'Người theo dõi',
      addWatcher: 'Thêm người theo dõi',
      epic: 'Epic',
      project: 'Dự án',
      crm: 'Liên kết CRM',
      crmKinds: {
        deal: 'Giao dịch',
        client: 'Khách hàng',
        agent: 'Đại lý',
      },
      created: 'Tạo {date}',
      updated: 'Cập nhật {date}',
    },
    error: {
      title: 'Không tải được nhiệm vụ',
      description: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
    },
  },
  board: {
    dropHere: 'Thả để chuyển vào đây',
    loadMore: 'Hiển thị thêm {count}',
    loadingMore: 'Đang tải…',
    moveFailed: 'Không chuyển được nhiệm vụ',
    scrollToEnd: 'Đến cột cuối',
    scrollToStart: 'Đến cột đầu',
    nothingFound: {
      title: 'Không tìm thấy gì',
      description: 'Có nhiệm vụ, nhưng không có cái nào khớp bộ lọc. Hãy bỏ lọc hoặc đổi truy vấn.',
    },
    empty: {
      title: 'Bảng đang trống',
      description: 'Hãy tạo nhiệm vụ đầu tiên — hoặc kéo một thẻ từ cột khác vào đây.',
    },
    error: {
      title: 'Không tải được bảng',
      description: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
      retry: 'Thử lại',
    },
  },
  projects: {
    summary: {
      projects: '{count} dự án',
      issues: '{count} công việc đang mở',
      mine: 'bạn tham gia {count}',
    },
    searchPlaceholder: 'Tìm dự án…',
    filters: {
      label: 'Hiển thị dự án nào',
      all: 'Tất cả',
      mine: 'Của tôi',
      archived: 'Lưu trữ',
    },
    card: {
      inProgress: '{count} đang làm',
      open: '{count} mở',
      private: 'Dự án riêng tư',
    },
    empty: {
      title: 'Chưa có dự án',
      description: 'Tạo dự án đầu tiên — mã, tên và hồ sơ loại công việc.',
    },
    nothingFound: {
      title: 'Không tìm thấy',
      description: 'Thử từ khoá khác hoặc bỏ bộ lọc.',
    },
    error: {
      title: 'Không tải được danh sách dự án',
      description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
      retry: 'Thử lại',
    },
    create: {
      action: 'Tạo dự án',
      title: 'Dự án mới',
      key: 'Mã',
      keyPlaceholder: 'DEV',
      name: 'Tên',
      namePlaceholder: 'Phát triển',
      description: 'Mô tả',
      descriptionPlaceholder: 'Dự án nói về gì và ai làm việc trong đó',
      profile: 'Hồ sơ dự án',
      profiles: {
        development: 'Phát triển',
        simple: 'Đơn giản',
      },
      profileHint: {
        development:
          'Epic, story, công việc, lỗi, công việc con. Bảng: backlog, cần làm, đang làm, review, kiểm thử, xong.',
        simple: 'Chỉ công việc và công việc con. Bảng: cần làm, đang làm, xong.',
      },
      private: 'Dự án riêng tư',
      privateHint: 'Dự án riêng tư chỉ hiển thị với thành viên của nó.',
      submit: 'Tạo',
      errors: {
        key: 'Chữ Latinh in hoa, từ hai đến mười ký tự',
        failed: 'Không tạo được dự án',
      },
    },
  },
  settings: {
    personal: {
      title: 'Cài đặt',
    },
    integrations: {
      title: 'Tích hợp',
      connect: {
        title: 'Kết nối tác nhân',
        step1: 'Phát hành khoá truy cập',
        step2: 'Chạy lệnh trong terminal',
        step2Hint: 'Thay khoá vừa phát hành vào chỗ dấu ba chấm: tracker không lưu khoá và không thể hiển thị lại lần thứ hai.',
        copy: 'Sao chép',
        copied: 'Đã sao chép',
        repo: '— mã nguồn MCP server và danh sách đầy đủ công cụ',
      },
      keys: {
        title: 'Khoá truy cập',
        hint: 'Khoá hoạt động thay bạn và không thể làm nhiều hơn bạn. Tối đa {limit} khoá đang hoạt động.',
        hintNoLimit: 'Khoá hoạt động thay bạn và không thể làm nhiều hơn bạn.',
        issue: 'Phát hành khoá',
        revoke: 'Thu hồi',
        revoked: 'Đã thu hồi khoá «{name}»',
        empty: 'Chưa có khoá nào',
        emptyHint: 'Hãy phát hành khoá đầu tiên bằng nút phía trên — khoá sẽ xuất hiện trong danh sách này.',
        until: 'đến {date}',
        revokedAt: 'thu hồi {date}',
        expired: 'đã hết hạn',
        neverUsed: 'chưa dùng',
        today: 'hôm nay, {time}',
        yesterday: 'hôm qua',
        daysAgo: '{n} ngày trước',
        columns: {
          name: 'Tên',
          access: 'Quyền',
          lastUsed: 'Lần dùng cuối',
          expiry: 'Hạn',
        },
        scopes: {
          all: 'toàn bộ quyền của bạn',
          tasks: 'công việc',
          tasksRead: 'công việc — chỉ đọc',
          knowledge: 'cơ sở tri thức',
        },
      },
      capabilities: {
        title: 'Tác nhân làm gì với khoá của bạn',
        reads: {
          title: 'Đọc',
          items: [
            'Dự án, bảng, cột và nhãn',
            'Công việc, bình luận, lịch sử và liên kết',
            'Nhánh, MR và pipeline của công việc',
            'Trang cơ sở tri thức',
          ],
        },
        writes: {
          title: 'Thay đổi',
          items: [
            'Tạo công việc lẻ và theo lô',
            'Sửa trường và mô tả',
            'Chuyển giữa các cột, gắn nhãn',
            'Viết bình luận và liên kết công việc',
          ],
        },
        cannot: {
          title: 'Không thể',
          items: [
            'Chạy release hay bật tắt cờ tính năng',
            'Dựng và xoá môi trường tính năng',
            'Xoá công việc, dự án và trang',
            'Phát hành khoá mới',
          ],
        },
      },
      dialog: {
        title: 'Phát hành khoá truy cập',
        doneTitle: 'Đã phát hành khoá',
        name: 'Tên',
        namePlaceholder: 'Claude Code · laptop',
        access: 'Quyền',
        scopeHint: 'Khoá không thể làm nhiều hơn bạn: quyền của nó giao với quyền của bạn. Release, cờ tính năng và môi trường không bao giờ nằm trong khoá.',
        scopes: {
          'tracker:read': 'Công việc — đọc',
          'tracker:write': 'Công việc — ghi',
          'knowledge:read': 'Cơ sở tri thức — đọc',
          'knowledge:write': 'Cơ sở tri thức — ghi',
        },
        lifetime: 'Thời hạn',
        ttl: {
          API_KEY_TTL_30_DAYS: '30 ngày',
          API_KEY_TTL_90_DAYS: '90 ngày',
          API_KEY_TTL_180_DAYS: '180 ngày',
          API_KEY_TTL_365_DAYS: 'Một năm',
        },
        submit: 'Phát hành',
        done: 'Xong',
        secretHint: 'Hãy sao chép khoá ngay: nó chỉ hiện một lần và sẽ không xuất hiện ở đâu nữa.',
        secretWarning: 'Khoá hoạt động thay bạn. Đừng đưa khoá vào repository và đừng gửi qua tin nhắn.',
        errors: {
          create: 'Không phát hành được khoá',
        },
      },
      errors: {
        load: 'Không tải được danh sách khoá',
        revoke: 'Không thu hồi được khoá',
        copy: 'Không dùng được clipboard',
      },
    },
    cancel: 'Bỏ thay đổi',
    save: 'Lưu',
    saved: 'Đã lưu cài đặt',
    saveFailed: 'Không thể lưu cài đặt',
    error: {
      title: 'Không tải được cài đặt',
      description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
    },
    tabs: {
      columns: 'Cột',
      members: 'Thành viên',
      types: 'Loại công việc',
      general: 'Chung',
    },
    columns: {
      preset: 'Mẫu:',
      presets: {
        COLUMN_PRESET_DEVELOPMENT: 'Phát triển · 6 cột có WIP',
        COLUMN_PRESET_SIMPLE: 'Đơn giản · 3 cột không giới hạn',
      },
      presetLocked:
        'Mẫu thay toàn bộ bảng nên chỉ áp dụng cho dự án trống — dự án này đã có công việc.',
      hint: 'Mẫu tạo bộ cột ban đầu. Sau đó có thể sửa: tên, màu, nhóm trạng thái và giới hạn WIP.',
      categories: {
        STATUS_CATEGORY_OPEN: 'Đang mở',
        STATUS_CATEGORY_IN_PROGRESS: 'Đang làm',
        STATUS_CATEGORY_DONE: 'Hoàn thành',
      },
      name: 'Tên cột',
      color: 'Màu cột',
      wip: 'WIP:',
      wipLabel: 'Giới hạn WIP của cột {name}',
      remove: 'Xoá cột {name}',
      add: 'Thêm cột',
      newName: 'Cột mới',
      moveTitle: 'Chuyển công việc đi đâu',
      moveText: 'Cột đang có {count} công việc — chọn nơi chuyển đến.',
      moveTarget: 'Cột đích',
      moveSubmit: 'Xoá cột',
    },
    members: {
      remove: 'Loại {name} khỏi dự án',
      title: 'Thành viên',
      searchPlaceholder: 'Tên hoặc email nhân viên VINPROP',
      role: 'Vai trò',
      add: 'Thêm',
      nobody: 'Không tìm thấy ai',
      noDirectory: 'Không truy cập được danh bạ nhân viên: cần quyền users:read',
      directoryRoles: {
        ADMIN: 'Quản trị viên',
        ADMIN_USER: 'Quản trị viên',
        CEO: 'Ban lãnh đạo',
        HOS: 'Trưởng phòng kinh doanh',
        PROJECT_MANAGER: 'Quản lý dự án',
        MANAGER: 'Quản lý',
        MARKETER: 'Marketing',
        SUPPORT_MANAGER: 'Hỗ trợ',
        CONTENT_AUTHOR: 'Nội dung',
      },
      roles: {
        MEMBER_ROLE_ADMIN: 'Quản trị',
        MEMBER_ROLE_MEMBER: 'Thành viên',
        MEMBER_ROLE_VIEWER: 'Người xem',
      },
      hint: 'Quản trị — cài đặt, thành viên và xoá công việc. Thành viên — làm việc với công việc và bảng. Người xem — chỉ đọc. Quyền vào tracker được cấp trong auth.',
    },
    types: {
      profiles: {
        TYPE_PROFILE_DEVELOPMENT: 'Hồ sơ: phát triển',
        TYPE_PROFILE_SIMPLE: 'Hồ sơ: đơn giản',
      },
      hint: 'Bộ loại là cố định: Epic → Story → Task và Bug → Subtask. Hồ sơ bật tắt các loại, không tạo loại riêng.',
      notes: {
        ISSUE_TYPE_EPIC: 'Cấp cao nhất: mục tiêu kéo dài vài tuần, gom story và task',
        ISSUE_TYPE_STORY: 'Giá trị cho người dùng, chia thành các task',
        ISSUE_TYPE_TASK: 'Đơn vị công việc của một người thực hiện',
        ISSUE_TYPE_BUG: 'Lỗi: có màu riêng và mặc định ưu tiên cao',
        ISSUE_TYPE_SUBTASK: 'Danh sách kiểm bên trong công việc, không lên bảng',
      },
      count: '{count} công việc',
    },
    general: {
      archive: 'Lưu trữ',
      archiveTitle: 'Lưu trữ dự án',
      restoreTitle: 'Khôi phục dự án',
      archiveNote:
        'Dự án lưu trữ rời khỏi trang chính và thanh bên. Nhiệm vụ vẫn mở được bằng liên kết.',
      archiveAction: 'Lưu trữ',
      restoreAction: 'Khôi phục',
      archiveAsk:
        'Dự án sẽ biến mất khỏi trang chính và điều hướng. Bạn có thể khôi phục ở màn hình này.',
      restoreAsk: 'Dự án sẽ xuất hiện lại ở trang chính và thanh bên.',
      archived: 'Dự án đã được lưu trữ',
      restored: 'Dự án đã được khôi phục',
      name: 'Tên dự án',
      key: 'Khoá',
      keyNote: 'Không đổi được khoá: số hiệu công việc và liên kết nhánh GitLab phụ thuộc vào nó.',
      description: 'Mô tả',
      access: 'Truy cập và quy tắc',
      private: 'Dự án riêng tư',
      privateNote: 'Chỉ thành viên dự án và quản trị viên nhìn thấy',
    },
  },
  editor: {
    mention: {
      empty: 'Không tìm thấy ai',
    },
  },
  app: {
    name: 'VP Tracker',
  },
  login: {
    title: 'Đăng nhập',
    email: 'Email',
    emailPlaceholder: "mk{'@'}vinprop.vn",
    password: 'Mật khẩu',
    passwordPlaceholder: '••••••••••',
    showPassword: 'Hiện mật khẩu',
    hidePassword: 'Ẩn mật khẩu',
    submit: 'Đăng nhập',
    or: 'hoặc',
    google: 'Đăng nhập bằng Google Workspace',
    footer: "Quyền truy cập do quản trị viên VINPROP cấp · vp-adm{'@'}vinprop.vn",
    errors: {
      invalid: 'Email hoặc mật khẩu không đúng',
      unavailable: 'Dịch vụ đăng nhập không khả dụng. Thử lại sau một phút',
    },
  },
  nav: {
    knowledgeShort: 'CSTT',
    myTasksShort: 'Của tôi',
    mobile: 'Điều hướng',
    myTasks: 'Việc của tôi',
    projects: 'Dự án',
    calendar: 'Lịch',
    devops: 'DevOps',
    knowledge: 'Cơ sở tri thức',
    assistant: 'Trợ lý',
    projectsOverline: 'Dự án',
    addProject: 'Thêm dự án',
    board: 'Bảng',
    issues: 'Công việc',
    epics: 'Epic',
    projectSettings: 'Cài đặt dự án',
    settings: 'Cài đặt',
    userMenu: 'Menu người dùng',
    collapse: 'Thu gọn menu',
    expand: 'Mở rộng menu',
    logout: 'Đăng xuất',
  },
  toolbar: {
    search: 'Tìm kiếm…',
    create: 'Tạo mới',
    view: {
      label: 'Chế độ xem dự án',
      board: 'Bảng',
      list: 'Danh sách',
    },
    filters: {
      assignee: 'Người thực hiện',
      type: 'Loại',
      priority: 'Ưu tiên',
      reset: 'Bỏ lọc',
      empty: 'Không có lựa chọn nào',
    },
  },
  views: {
    board: 'Bảng',
    issues: 'Công việc',
    epics: 'Epic',
    calendar: 'Lịch',
    devops: 'DevOps',
    knowledge: 'Cơ sở tri thức',
    myTasks: 'Việc của tôi',
    settings: 'Cài đặt dự án',
  },
  errors: {
    forbidden: {
      ask: 'Xin quyền truy cập',
      asked: 'Đã gửi yêu cầu. Quản trị viên dự án sẽ thấy nó trong thông báo.',
      askFailed: 'Không gửi được yêu cầu',
      title: 'Không có quyền vào dự án',
      description: 'Dự án ở chế độ riêng tư. Hãy xin quyền từ quản trị viên dự án.',
    },
    notFound: {
      title: 'Không tìm thấy trang',
      description: 'Hãy kiểm tra địa chỉ: mục có thể đã đổi tên, công việc đã bị chuyển hoặc xoá.',
    },
    back: 'Về việc của tôi',
  },
  assistant: {
    title: 'Trợ lý',
    you: 'Bạn',
    close: 'Đóng bảng',
    history: 'Các cuộc trò chuyện trước',
    newThread: 'Cuộc trò chuyện mới',
    noThreads: 'Chưa có cuộc trò chuyện nào về trang này',
    untitled: 'Không có tiêu đề',
    resize: 'Chiều rộng bảng',
    placeholder: 'Hỏi hoặc ra lệnh…',
    stop: 'Dừng',
    waiting: 'Đang viết câu trả lời…',
    quota: 'Hôm nay còn {remaining} trên {limit} lượt',
    limit: {
      at: 'Đã hết lượt trong ngày. Sẽ làm mới lúc {time}',
      later: 'Đã hết lượt trong ngày. Sẽ làm mới vào ngày mai',
    },
    unavailable: {
      title: 'Trợ lý tạm thời không khả dụng',
      text: 'Dịch vụ mô hình không phản hồi. Cuộc trò chuyện vẫn được giữ — hãy thử lại sau một phút.',
      retry: 'Thử lại',
    },
    disclaimer:
      'Trợ lý nhìn thấy trang đang mở và làm việc với nhiệm vụ thay mặt bạn. Câu hỏi và các nhiệm vụ mà trợ lý đọc sẽ được gửi tới Google Gemini — đừng dán dữ liệu cá nhân của khách hàng.',
    suggestions: {
      board: 'Tóm tắt những gì đang diễn ra trên bảng',
      overdue: 'Việc nào đã quá hạn trong dự án DEV',
      compose: 'Tạo nhiệm vụ từ đoạn văn của tôi',
    },
    tool: {
      running: 'đang chạy…',
      failed: 'không thành công',
      retry: 'Thử lại',
      seconds: '{value} giây',
      issues: '{n} nhiệm vụ',
      pages: '{n} trang',
    },
    draft: {
      badge: 'bản nháp',
      field: {
        title: 'tiêu đề',
        description_md: 'mô tả',
      },
      inEpic: 'trong {key}',
      apply: 'Áp dụng',
      create: 'Tạo {n} nhiệm vụ',
      decline: 'Hủy',
      applied: 'Đã áp dụng',
      declined: 'Đã từ chối',
    },
    context: {
      board: 'Bảng',
      issues: 'Nhiệm vụ',
      epics: 'Epic',
      'project-settings': 'Cài đặt dự án',
      'knowledge-page': 'Trang cơ sở tri thức',
      'knowledge-page-edit': 'Trang cơ sở tri thức',
      'my-tasks': 'Nhiệm vụ của tôi',
      projects: 'Dự án',
      calendar: 'Lịch',
    },
    errors: {
      thread: 'Không mở được cuộc trò chuyện',
      stream: 'Trợ lý không khả dụng, hãy thử lại',
    },
  },
  palette: {
    tab: 'Tìm kiếm',
    title: 'Hỏi trợ lý hoặc chuyển nhanh',
    placeholder: 'Hãy hỏi hoặc ra lệnh…',
    hint: 'Gõ hai ký tự để tìm trang. Mã dạng DEV-1421 sẽ mở nhiệm vụ.',
    nothing: 'Không tìm thấy gì',
    openIssue: 'Mở nhiệm vụ {key}',
    groups: {
      ask: 'Hỏi',
      find: 'Tìm',
      create: 'Tạo',
      understand: 'Hiểu',
      jump: 'Chuyển tới',
    },
    meta: {
      assistant: 'trợ lý',
      knowledge: 'cơ sở tri thức',
      draft: 'bản nháp',
    },
    commands: {
      mine: 'Nhiệm vụ của tôi trong tuần này',
      overdue: 'Việc nào quá hạn trong dự án {key}',
      overdueAll: 'Việc nào quá hạn trong các dự án của tôi',
      knowledge: 'Trả lời theo cơ sở tri thức',
      knowledgeFill: 'Trả lời theo cơ sở tri thức: ',
      compose: 'Soạn nhiệm vụ từ đoạn văn bản',
      composeFill: 'Soạn nhiệm vụ từ đoạn văn bản này: ',
      decompose: 'Chia epic thành các nhiệm vụ',
      decomposeFill: 'Chia epic này thành các nhiệm vụ: ',
      stuck: 'Vì sao nhiệm vụ đứng yên',
      stuckIssue: 'Vì sao {key} đứng yên',
      stuckFill: 'Vì sao nhiệm vụ này đứng yên: ',
      digest: 'Tóm tắt bảng trong tuần',
    },
    footer: {
      select: '↑↓ chọn',
      run: '↵ thực hiện',
      next: '↵ câu hỏi tiếp theo',
      here: 'Câu trả lời sẽ hiện ở đây',
      expand: 'Mở rộng vào bảng điều khiển',
    },
  },
  onboarding: {
    title: 'Bắt đầu · {done}/{total}',
    steps: {
      project: 'Tạo dự án',
      issue: 'Tạo nhiệm vụ đầu tiên',
      columns: 'Thiết lập cột bảng',
      team: 'Mời đồng đội',
    },
  },
  calendar: {
    scope: {
      label: 'Nhiệm vụ của ai',
      mine: 'Của tôi',
      watching: 'Đang theo dõi',
    },
    today: 'Hôm nay',
    prev: 'Tháng trước',
    next: 'Tháng sau',
    more: 'thêm {count}',
    empty: 'Tháng này không có hạn nào.',
    withoutDue: 'Không có hạn: {count}',
    error: {
      title: 'Không mở được lịch',
      description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
    },
  },
  hub: {
    activity: {
      title: 'Hoạt động gần đây',
      empty: 'Chưa có sự kiện nào. Nhiệm vụ mới, bình luận và lần triển khai sẽ xuất hiện ở đây.',
      someone: 'Ai đó',
      today: 'Hôm nay',
      yesterday: 'Hôm qua',
      more: 'Xem thêm',
      loading: 'Đang tải…',
      verbs: {
        created: 'đã tạo nhiệm vụ',
        moved: 'đã chuyển',
        comment: 'đã bình luận',
        merged: 'đã gộp',
        devops: 'đã triển khai',
        other: 'đã thay đổi',
      },
    },
  },
  kb: {
    space: 'Không gian',
    updated: 'cập nhật {when}',
    version: 'phiên bản {version}',
    related: 'Nhiệm vụ liên quan',
    error: {
      title: 'Không mở được cơ sở tri thức',
      description: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
    },
    empty: {
      title: 'Cơ sở tri thức trống',
      description: 'Chưa có không gian nào — hãy tạo cái đầu tiên, trang sẽ xuất hiện ở thanh bên.',
    },
    pick: {
      title: 'Hãy chọn một trang',
      description: 'Cây trang của không gian nằm ở thanh bên trái.',
    },
    newSpace: {
      title: 'Không gian mới',
      key: 'Mã',
      keyInvalid: 'Chữ latin in hoa và chữ số, từ hai đến mười sáu ký tự',
      name: 'Tên',
      create: 'Tạo không gian',
      failed: 'Không tạo được không gian',
    },
    blank: {
      title: 'Cơ sở tri thức trống',
      description: 'Hãy viết trang đầu tiên — nó sẽ xuất hiện trong cây bên trái.',
      create: 'Tạo trang',
    },
    edit: {
      action: 'Chỉnh sửa',
      cancel: 'Huỷ',
      crumb: '{title} — chỉnh sửa',
      titleLabel: 'Tiêu đề trang',
      titlePlaceholder: 'Tiêu đề trang',
      bodyPlaceholder: "Nội dung trang. / — khối, {'@'} — nhắc tên",
      savedAt: '✓ Đã lưu bản nháp lúc {time}',
      saveVersion: 'Lưu phiên bản',
      saveFailed: 'Không lưu được trang',
      versionSaved: 'Đã lưu phiên bản',
      restored: 'Đã khôi phục phiên bản v{number}',
      previewing: 'Đang xem phiên bản v{number}',
      closePreview: 'Đóng bản xem',
      commentLabel: 'Đã thay đổi gì',
      commentPlaceholder: 'Không bắt buộc: một dòng cho lịch sử',
    },
    versions: {
      title: 'Phiên bản',
      empty: 'Chưa có phiên bản nào. Nút «Lưu phiên bản» chụp lại trạng thái trang.',
      number: 'v{number}',
      current: 'hiện tại',
      open: 'Mở',
      restore: 'Khôi phục',
    },
    tree: {
      menu: 'Thao tác với trang',
      addChild: 'Thêm trang con',
      move: 'Di chuyển',
      delete: 'Xoá',
      newPage: 'Trang mới',
      newPageTitle: 'Trang mới',
      newParent: 'Chuyển tới',
      root: 'Về gốc không gian',
      moveTitle: 'Di chuyển «{title}»',
      deleteTitle: 'Xoá «{title}»?',
      deleteHint: 'Không thể khôi phục lại trang.',
      deleteWithChildren: 'Mọi trang con sẽ bị xoá cùng. Không thể khôi phục lại.',
      createFailed: 'Không tạo được trang',
      moveFailed: 'Không di chuyển được trang',
      deleteFailed: 'Không xoá được trang',
    },
  },
  my: {
    filters: {
      project: 'Dự án',
      statusLabel: 'Trạng thái',
      status: {
        STATUS_CATEGORY_OPEN: 'Cần làm',
        STATUS_CATEGORY_IN_PROGRESS: 'Đang làm',
        STATUS_CATEGORY_DONE: 'Xong',
      },
      dueLabel: 'Hạn',
      due: {
        today: 'Hôm nay',
        week: 'Tuần này',
      },
    },
    sort: {
      label: 'Thứ tự',
      due_date: 'Theo hạn',
      priority: 'Theo ưu tiên',
      updated_at: 'Theo cập nhật',
      key: 'Theo mã',
    },
    chips: {
      assigned: 'Giao cho tôi',
      watching: 'Đang theo dõi',
      overdue: 'Quá hạn',
    },
    due: {
      today: 'hôm nay',
      tomorrow: 'ngày mai',
    },
    error: 'Không tải được nhiệm vụ',
    errorHint: 'Dịch vụ không phản hồi. Hãy kiểm tra kết nối và thử lại.',
    empty: {
      assigned: {
        title: 'Chưa có nhiệm vụ nào giao cho bạn',
        description: 'Nhiệm vụ sẽ xuất hiện khi bạn được chỉ định làm người thực hiện.',
      },
      watching: {
        title: 'Bạn chưa theo dõi nhiệm vụ nào',
        description: 'Nhấn «Theo dõi» ở một nhiệm vụ — nó sẽ xuất hiện ở đây.',
      },
      overdue: {
        title: 'Không có nhiệm vụ quá hạn',
        description: 'Mọi hạn đều còn ở phía trước.',
      },
    },
  },
  epic: {
    list: {
        stand: {
          raise: 'Dựng stand',
          started: 'Stand {key} đang dựng — các dịch vụ của epic dùng chung một namespace',
          failed: 'Không dựng được stand cho epic',
        },
      search: 'Tìm epic…',
      create: 'Tạo epic',
      due: 'hạn {date}',
      error: {
        title: 'Không tải được epic',
        description: 'Dịch vụ không phản hồi. Kiểm tra kết nối và thử lại.',
      },
      empty: {
        title: 'Dự án chưa có epic',
        description: 'Epic gom một khối công việc lớn: câu chuyện, nhiệm vụ và lỗi.',
      },
      nothingFound: {
        title: 'Không tìm thấy gì',
        description: 'Có epic, nhưng không cái nào khớp truy vấn. Kiểm tra chính tả.',
      },
    },
    summary: {
      total: '{count} nhiệm vụ',
      done: '{count} xong',
      inProgress: '{count} đang làm',
      open: '{count} đang mở',
    },
    progressLabel: 'Mức hoàn thành epic',
    empty: 'Epic chưa có nhiệm vụ nào',
    pipelines: 'Pipeline của epic · theo dịch vụ',
    noPipelines: 'Chưa có lần chạy nào cho nhiệm vụ của epic',
    ops: 'Cờ và môi trường',
    activityGap: 'Chưa có dòng sự kiện của epic: tracker chỉ lưu lịch sử của từng nhiệm vụ.',
  },
  devops: {
    stand: {
      raise: 'Dựng môi trường',
      drop: 'Tắt môi trường',
    },
    pipelines: {
      title: 'Pipeline',
      project: 'Dự án',
      allProjects: 'Tất cả dự án',
      unassigned: 'Không có nhiệm vụ',
      status: 'Trạng thái',
      noProjects: 'Không có gì để chọn',
      searchPlaceholder: 'Tìm kiếm…',
      groupBy: 'Nhóm các lần chạy',
      byEpic: 'Theo epic',
      byService: 'Theo dịch vụ',
      window: 'Khoảng',
      windowDays: '{days} ngày',
      open: 'Mở trong GitLab',
      error: 'Không tải được các lần chạy',
      errorHint: 'Bảng tổng hợp pipeline không khả dụng. Hãy thử lại.',
      kpi: {
        success: 'Thành công · 24 giờ',
        successHint: 'trên {total}',
        failed: 'Thất bại',
        running: 'Đang chạy',
        duration: 'Thời lượng trung bình',
        delta: '{delta} giây so với hôm qua',
      },
      empty: {
        title: 'Chưa có lần chạy nào',
        description:
          'Tracker biết về các lần chạy qua webhook GitLab: chúng xuất hiện sau lần push đầu tiên vào nhánh nhiệm vụ.',
      },
    },
    services: {
      add: 'Thêm dịch vụ',
      remove: 'Bỏ {name}',
      noRepositories: 'Chưa có kho mã nào được kết nối',
      suggested: 'Nhánh của nhiệm vụ này đã xuất hiện trong {name}',
      addSuggested: '— thêm vào dịch vụ?',
    },
    envs: {
      title: 'Môi trường tính năng',
      searchPlaceholder: 'Tìm kiếm…',
      refresh: 'Làm mới',
      retry: 'Thử lại',
      error: 'Không tải được danh sách môi trường',
      errorHint: 'GitLab không trả lời về môi trường. Hãy thử lại.',
      actionError: 'Không thực hiện được — hãy kiểm tra pipeline trong GitLab.',
      noIssue: 'không có nhiệm vụ',
      noUrl: 'chưa triển khai',
      autoStopIn: 'tự tắt sau {time}',
      note: 'Môi trường được dựng theo bộ: mỗi dịch vụ của nhiệm vụ vào chung một namespace dev-NNNN, frontend không có nhánh riêng thì lấy master. Liên kết xuất hiện dần theo tiến độ triển khai — chỉ thứ đã triển khai mới có địa chỉ. «Tắt» xoá toàn bộ môi trường: namespace dùng chung cho mọi dịch vụ.',
      columns: {
        stand: 'Môi trường',
        issue: 'Nhiệm vụ',
        services: 'Thành phần',
        actor: 'Người dựng',
        uptime: 'Thời gian chạy',
        actions: 'Thao tác',
      },
      state: {
        active: 'đang chạy',
        building: 'đang build',
        idle: 'bỏ không',
        buildingUptime: '—',
      },
      uptime: {
        days: 'ngày',
        hours: 'giờ',
        minutes: 'phút',
      },
      metrics: {
        active: 'Môi trường đang chạy',
        activeHint: 'đang hoạt động',
        building: 'Đang dựng',
        idle: 'Bỏ không quá {days} ngày',
        idleHint: 'nên gỡ bỏ',
      },
      filters: {
        project: 'Dịch vụ',
        state: 'Trạng thái',
        noProjects: 'Không có gì để chọn',
      },
      actions: {
        open: 'Mở môi trường',
        redeploy: 'Dựng lại',
        drop: 'Tắt',
        noIssueHint: 'Môi trường không dựng từ nhiệm vụ — không có bộ dịch vụ để dựng lại',
      },
      empty: {
        title: 'Chưa có môi trường nào đang chạy',
        description: 'Dựng môi trường từ thẻ nhiệm vụ hoặc bằng nút trên thanh công cụ.',
      },
      raise: {
        title: 'Dựng môi trường',
        titleFor: 'Dựng môi trường {key}',
        namespace: '{stand} · namespace {name} · tự tắt sau 3 ngày không dùng',
        composition: 'Thành phần — dịch vụ của nhiệm vụ',
        issue: 'Nhiệm vụ',
        unknownIssue: 'Không có nhiệm vụ với mã này',
        pickIssue: 'Hãy chỉ định nhiệm vụ — thành phần lấy từ đó',
        noServices: 'Nhiệm vụ chưa khai báo dịch vụ. Hãy thêm trong thẻ — môi trường được dựng từ chúng.',
        servicesFailed: 'Không đọc được dịch vụ của nhiệm vụ',
        ownBranch: 'nhánh riêng',
        noOwnBranch: 'không có nhánh của nhiệm vụ',
        addService: 'Thêm vào',
      },
    },
    flags: {
      loading: 'Đang tải…',
      button: 'Cờ tính năng',
      title: 'Cờ tính năng',
      note: 'Cờ được bật tắt bằng commit vào features/dev.json hoặc features/prod.json của repo hạ tầng. Git là nguồn sự thật, tracker hiển thị trạng thái và lịch sử.',
      new: 'Cờ mới',
      newTitle: 'Cờ mới',
      newHint:
        'Cờ được tạo ở cả hai môi trường: bật ở môi trường đã chọn, tắt ở môi trường còn lại. Lint hạ tầng yêu cầu như vậy.',
      keyInvalid: 'Khoá dạng dev-1476-devops-screens: có số nhiệm vụ và viết thường',
      create: 'Tạo cờ',
      error: 'Không tải được danh sách cờ',
      errorHint: 'Không đọc được tệp cờ: hãy kiểm tra tích hợp GitLab.',
      toggleError: 'Không chuyển được cờ',
      recent: 'Thay đổi gần đây',
      turnedOn: 'đã bật trên {environment}',
      turnedOff: 'đã tắt trên {environment}',
      noIssue: 'khoá không chứa mã nhiệm vụ',
      searchPlaceholder: 'Tìm kiếm…',
      columns: {
        flag: 'Cờ',
        what: 'Nhiệm vụ',
        changed: 'Thay đổi cuối',
      },
      filters: {
        environment: 'Môi trường',
        empty: 'Không có gì để chọn',
      },
      empty: {
        title: 'Chưa có cờ nào',
        description:
          'Hãy tạo cờ đầu tiên — nó sẽ xuất hiện trong features/dev.json và features/prod.json.',
      },
    },
    repos: {
      title: 'Kho mã nguồn',
      sync: 'Đồng bộ ngay',
      ago: '{time} trước',
      events: 'push · MR · pipeline',
      noEvents: 'chưa có sự kiện',
      open: 'Mở trong GitLab',
      connect: 'Kết nối',
      recheck: 'Kết nối lại',
      disconnect: 'Ngắt kết nối',
      error: 'Không tải được danh sách kho',
      empty: 'Chưa có kho nào',
      emptyHint: 'Chưa chạy đồng bộ hoặc nhóm chưa có dự án',
      syncDone: 'Đã kiểm tra {checked}, kết nối {connected}, lỗi {failed}',
      syncFailed: 'Đồng bộ thất bại',
      connected: 'Đã kết nối {path}',
      connectFailed: 'Không kết nối được kho',
      disconnected: 'Đã ngắt {path}',
      disconnectFailed: 'Không ngắt được kho',
      note: 'Webhook cấp nhóm là tính năng trả phí của GitLab, nên hook phải đặt trên từng kho. Trình theo dõi tự đối chiếu danh sách nhóm theo lịch và đặt hook ở nơi còn thiếu: kho mới tự kết nối.',
      filters: {
        state: 'Trạng thái',
      },
      columns: {
        path: 'Kho mã nguồn',
        events: 'Sự kiện',
        lastEvent: 'Sự kiện gần nhất',
        actions: 'Thao tác',
      },
      state: {
        connected: 'đã kết nối',
        missing: 'chưa có hook',
        failed: 'hook bị tắt',
        muted: 'đã ngắt',
      },
      metrics: {
        connected: 'Đã kết nối',
        connectedHint: 'trên {total} kho',
        missing: 'Chưa có hook',
        missingHint: 'không nhận sự kiện',
        failed: 'Lỗi',
        failedHint: 'GitLab từ chối hook',
        synced: 'Đối chiếu',
        syncedHint: 'lần gần nhất',
      },
    },
    releases: {
      views: {
        label: 'Kiểu lịch sử',
        flat: 'Danh sách',
        grouped: 'Theo kho',
      },
      inRepository: '{n} bản phát hành',
      title: 'Bản phát hành',
      history: 'Lịch sử phát hành',
      searchPlaceholder: 'Tìm kiếm…',
      error: 'Không tải được bản phát hành',
      errorHint: 'Nhật ký thao tác không khả dụng. Hãy thử lại.',
      tagged: 'đã đặt tag',
      failed: 'lỗi',
      open: 'Mở trong GitLab',
      note: 'Tag được tạo qua GitLab API. Triển khai lên prod bằng nút trên dòng bản phát hành, khi pipeline chạm tới job thủ công.',
      filters: {
        service: 'Dịch vụ',
        period: 'Khoảng thời gian',
        days: '{days} ngày gần đây',
        buildLabel: 'Bản dựng',
        build: {
          success: 'Thành công',
          failed: 'Thất bại',
          running: 'Đang chạy',
          none: 'Chưa dựng',
        },
        empty: 'Không có gì để chọn',
      },
      order: {
        label: 'Thứ tự',
        newest: 'Mới nhất trước',
        oldest: 'Cũ nhất trước',
      },
      noBuild: 'chưa dựng',
      deploy: {
        action: 'Triển khai lên prod',
        confirmTitle: 'Triển khai {tag} lên prod?',
        confirmBody: 'Trình theo dõi sẽ bấm job thủ công deploy-prod trong pipeline của tag — đúng job bạn sẽ bấm trong GitLab. Không thể dừng việc triển khai từ trình theo dõi.',
        pipeline: 'pipeline #{id}',
        submit: 'Triển khai',
        failed: 'Không khởi chạy được việc triển khai',
      },
      empty: {
        title: 'Chưa có bản phát hành nào',
        description:
          'Chưa có tag nào được tạo qua tracker. Tag đặt bằng tay không nằm trong nhật ký.',
      },
    },
    release: {
      button: 'Phát hành',
      title: 'Tạo bản phát hành',
      hint: 'Tag được đặt trên master. Danh sách dịch vụ chỉ là gợi ý, có thể nhập kho mã bằng tay.',
      service: 'Dịch vụ',
      tag: 'Phiên bản',
      tagInvalid: 'Phiên bản dạng v1.4.0',
      description: 'Mô tả',
      generate: 'Tạo tự động',
      generating: 'Trợ lý đang đọc lịch sử…',
      generated: 'Trợ lý tổng hợp từ {commits} commit sau {tag}. Hãy kiểm tra trước khi đặt tag.',
      generateFailed: 'Không tổng hợp được mô tả',
      replaceTitle: 'Thay mô tả bạn đã nhập?',
      replace: 'Thay',
      create: 'Đặt tag',
    },
  },
}
